var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84082 12.6768L10.1742 16.0101L13.5075 12.6768",
    stroke: "#D70900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1743 8.50977V16.0098",
    stroke: "#D70900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5741 13.5847C18.2986 13.0752 18.8419 12.3482 19.1252 11.509C19.4085 10.6698 19.417 9.76222 19.1495 8.9179C18.882 8.07357 18.3524 7.33645 17.6375 6.81351C16.9227 6.29057 16.0598 6.00902 15.1741 6.00971H14.1241C13.8735 5.03294 13.4045 4.12575 12.7526 3.35644C12.1006 2.58714 11.2826 1.97576 10.3601 1.56834C9.4377 1.16092 8.43484 0.968066 7.42708 1.00431C6.41931 1.04055 5.4329 1.30494 4.5421 1.77757C3.6513 2.25019 2.87933 2.91875 2.28429 3.7329C1.68926 4.54705 1.28668 5.48558 1.10686 6.47783C0.92703 7.47009 0.974647 8.49021 1.24612 9.46139C1.5176 10.4326 2.00585 11.3295 2.67414 12.0847",
    stroke: "#D70900",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.67b0953009150b232021960952787f2e.svg";
export { ForwardRef as ReactComponent };